
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 33 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.73 48H4.271A4.315 4.315 0 010 43.651V20.8a9.081 9.081 0 011.339-4.754l1.974-3.214a4.187 4.187 0 00.616-2.189V8.8a.8.8 0 01-.787-.8V.8a.794.794 0 01.787-.8h25.143a.794.794 0 01.786.8V8a.794.794 0 01-.786.8v1.843a4.172 4.172 0 00.616 2.188l1.973 3.214A9.08 9.08 0 0133 20.8v22.851A4.315 4.315 0 0128.73 48zM1.607 44a2.715 2.715 0 002.664 2.4h24.458a2.717 2.717 0 002.665-2.4H18.858V20h12.516a7.4 7.4 0 00-1.045-3.106l-1.973-3.214a5.783 5.783 0 01-.856-3.036V8.8h-22v1.843a5.791 5.791 0 01-.856 3.036l-1.973 3.214A7.4 7.4 0 001.627 20h5.445v24zm18.822-22.4v20.8h11v-3.2h-7.857v-1.6h7.857V36h-7.857v-1.6h7.857v-1.6h-7.857v-1.6h7.857v-1.6h-7.857V28h7.857v-1.6h-7.857v-1.6h7.857v-3.2zm-18.858 0v20.8H5.5V21.6zm25.144-20v5.6h1.571V1.6zm-3.143 0v5.6h1.571V1.6zm-3.142 0v5.6H22V1.6zm-3.143 0v5.6h1.572V1.6zm-3.142 0v5.6h1.571V1.6zM11 1.6v5.6h1.572V1.6zm-3.142 0v5.6h1.57V1.6zm-3.142 0v5.6h1.57V1.6z","fill":"#56bdd2"}})])
          )
        }
      }
    